import { AddBox } from "@mui/icons-material";
import { Button } from "@mui/material";

export default function NewWordlistButton({ tryOpenNewWordlistModal }: { tryOpenNewWordlistModal: () => void }) {
    return <Button variant='contained' color='info' onClick={tryOpenNewWordlistModal} startIcon={<AddBox />}>New</Button>
}
